import styled from 'styled-components';
import { regularWhite } from '../../../design-tokens';
import { device } from '../../../breakpoints';
import { Heading2 } from '../../../typography/Heading.styles';
import PlayText from '../../../typography/PlayText/PlayText';
import { PlayPrefix } from '../../../typography/PlayPrefix.styles';

export const StyledCaption = styled.div`
    box-sizing: border-box;
    display: block;
    width: 100%;
    color: ${regularWhite};

    padding: 20px 15px 25px;

    @media ${device.GteMedium} {
        width: 50%;
        height: 100%;
        padding: 0;
        float: left;
        word-wrap: break-word;
        align-self: center;
        padding-left: 30px;
        padding-right: 30px;
    }

    @media ${device.GteLarge} {
        width: 33.333%;
    }

    @media ${device.FullScreen} {
        padding-right: 10px;
    }
`;

export const Heading = styled(Heading2)`
    display: inline-block;
    padding-bottom: 0.1em;
    margin-top: 0;

    @media ${device.GteXLarge} {
        padding-bottom: 0.3em;
    }
`;

export const CaptionText = styled(PlayText)`
    line-height: 1.4;
    margin-top: 2px;
`;

export const Byline = styled(PlayPrefix)`
    display: block;
    margin-bottom: 3px;
`;
